import React, { useMemo } from "react";
import { TouchableOpacity } from "react-native";
import { Text } from "@lookiero/sty-psp-ui";
import { theme } from "@lookiero/sty-psp-ui";
import { Icon } from "../icon/Icon";
import { style as buttonStyle } from "./Button.style";
const { iconSize: ThemeIconSize } = theme();
const ACTIVE_OPACITY = 0.6;
const Button = ({ children, title, checked, icon, iconSize = ThemeIconSize, testID, style: customStyle, component: Component = TouchableOpacity, onPress, }) => {
    const style = useMemo(() => buttonStyle(), []);
    const backgroundColor = checked ? style.colorBgInteractiveSelected : style.colorBgInteractiveActive;
    const textColor = checked ? style.colorIconActionOption : style.colorText;
    const iconColor = checked ? style.colorIconActionOption : style.colorIconLight;
    return (React.createElement(Component, { activeOpacity: ACTIVE_OPACITY, style: [style.button, { backgroundColor }, customStyle?.button], onPress: onPress },
        children,
        icon && (React.createElement(Icon, { name: icon, size: iconSize, style: [{ color: iconColor }, style.icon, customStyle?.icon] })),
        React.createElement(Text, { level: 1, style: [style.text, { color: textColor }, customStyle?.text], testID: testID, variant: "detail" }, title)));
};
export { Button };
